import vars from "Consts/vars";
import NextImage from "Components/fallback_image/next_image";
import CardSearchUser from "@fdn/card_search_user";
import handleLoadMoreLabel from "Helpers/loadMore";

const Desktop = (props) => {

	const prop = props;
	const limitData = 40;

	return (
		<div className="component-tab-user">
			{
				prop.dataUser?.data?.users.length > 0 ? (
					<>
						<div className="component-tab-user__section-title">
							<p className="component-tab-user__title title-user">Users</p>
						</div>
						<div className="component-tab-user__users">
							{
								prop.dataUser?.data?.users.map((data) => (
									<div key={data.usrapo_id}>
										<CardSearchUser
											key={data.usrapo_id}
											isMobile={prop.isMobile}
											domain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
											user={data}
											brokenImage={vars.BROKEN_IMAGE.square}
										>
											<NextImage
												width={60}
												height={60}
												placeholder="user"
												objectFit="cover"
												style={{ borderRadius: "50%" }}
												src={data.usrpic || vars.BROKEN_IMAGE.user}
												alt={data.username}
												fallbackSrc={vars.BROKEN_IMAGE.user}
											/>
										</CardSearchUser>

									</div>

								))
							}

						</div>
						{
							prop.dataUser?.data?.users.length < prop.dataUser?.pagination.total && (
								<div className="component-tab-user__section-more-data">
									<button
										type="button"
										className="component-tab-user__title-more-data"
										onClick={prop.handleLoadMoreUser}
										id="id-loadmore"
									>
										{handleLoadMoreLabel({
											page: prop.dataUser?.pagination.page,
											limit: limitData,
											total: prop.dataUser?.pagination.total,
											data: prop.dataUser?.data?.users,
											text: "Users",
										})}
									</button>
								</div>
							)
						}

					</>
				) : (
					<div className="component-tab-user__section-image-error">
						<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-user__image-error" />
						<h4 className="component-tab-user__title">Sorry, no result found</h4>
						<p className="component-tab-user__sub_title">Please try another keyword!</p>
					</div>
				)
			}
			<style jsx>
				{`
						.component-tab-user{
							padding-top: 10px;
							max-width: 1280px;
							margin: auto;
						}
						.component-tab-user__section-title{
							display: flex;
							margin-top: 36px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.component-tab-user__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.component-tab-user__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.component-tab-user__users{
							display: grid;
							grid-template-columns: repeat(4, 1fr);
							justify-items: stretch;
							gap: 20px;
						}
						.component-tab-user__section-more-data{
							display: flex;
    						justify-content: center;
							margin-top:24px;
						}
						.component-tab-user__title-more-data{
							font-family: 'Creato Display', sans-serif;
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							text-align: center;
							padding: 8px 16px;
							background: #fff;
							border: 1px solid #000;
							border-radius: 8px;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}
						.component-tab-user__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-user__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;

						}
						.component-tab-user__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-user__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Desktop;
